import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import colors from 'seagull/foundations/colors.module.scss';
export function Edit2Liner24Circle() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "10.5",
                cy: "11",
                r: "9",
                fill: colors.dark50
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.91724 3.78747C9.23974 5.85747 10.9197 7.43997 13.0047 7.64997M2.25 16.5H15.75M9.94525 2.69998L3.78775 9.21748C3.55525 9.46498 3.33025 9.95248 3.28525 10.29L3.00775 12.72C2.91025 13.5975 3.54025 14.1975 4.41025 14.0475L6.82525 13.635C7.16275 13.575 7.63525 13.3275 7.86775 13.0725L14.0253 6.55498C15.0903 5.42998 15.5703 4.14748 13.9128 2.57998C12.2628 1.02748 11.0103 1.57498 9.94525 2.69998Z",
                stroke: "currentColor",
                fill: "none",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                transform: "scale(0.5) translate(12 12)"
            })
        ]
    });
}
